import ContactUs1 from "../Components/contact-us-1";
import ContactUs2 from "../Components/contact-us-2";
import NewFooter from "../Components/new-footer";
function ContactUSPage() {
    return (
        <>
            <ContactUs1 />
            <ContactUs2 />
            <NewFooter />
        </>
    )
}
export default ContactUSPage;